"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatterTypeFromShortcut = exports.ShortcutKeys = exports.FormattersWithShortcuts = exports.FormatterMap = exports.getFormatterTypesOfKind = exports.getActiveFormatters = exports.applyMarkup = exports.lflf = void 0;
var TypedKeys_1 = require("../../utils/TypedKeys");
// eslint-disable-next-line import/no-cycle
var MarkupFormatters_1 = require("./MarkupFormatters");
exports.lflf = '\n\n';
var dispatchChangeEvent = function (textAreaElement, value) {
    var _a;
    var nativeInputValueSetter = (_a = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value')) === null || _a === void 0 ? void 0 : _a.set;
    nativeInputValueSetter === null || nativeInputValueSetter === void 0 ? void 0 : nativeInputValueSetter.call(textAreaElement, value);
    var inputEvent = new InputEvent('input', { bubbles: true });
    textAreaElement.dispatchEvent(inputEvent);
};
var applyMarkup = function (formatterType, textAreaElement) {
    var _a = getSelectionAndAdjacents(textAreaElement), selection = _a.selection, preSelection = _a.preSelection, postSelection = _a.postSelection;
    var map = exports.FormatterMap[formatterType];
    var markupFunction = getMarkupFunction(map.formatterApplicationType);
    var _b = markupFunction(preSelection, selection, postSelection, map.formatter, textAreaElement, map.prepend), replacement = _b.replacement, selectionPos = _b.selectionPos;
    // using document.execCommand('insertText') allows for undo/redo, but it doesn't work in ff
    // 5 yr old bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1220696
    if (!document.execCommand('insertText', false, replacement)) {
        // returns false in ff though, so we can manually set the value this way
        // We need to get updated selection info, because in some cases, it has changed
        var _c = getSelectionAndAdjacents(textAreaElement), updatedPreSelection = _c.preSelection, updatedPostSelection = _c.postSelection;
        var newValue = updatedPreSelection + replacement + updatedPostSelection;
        dispatchChangeEvent(textAreaElement, newValue);
    }
    // We blur before focusing to cause the textarea to correctly scroll the cursor/selection into view
    textAreaElement.blur();
    textAreaElement.focus();
    textAreaElement.selectionStart = selectionPos[0];
    textAreaElement.selectionEnd = selectionPos[0] + selectionPos[1];
};
exports.applyMarkup = applyMarkup;
var getSelectionAndAdjacents = function (textAreaElement) {
    if (!textAreaElement) {
        return { selection: '', preSelection: '', postSelection: '' };
    }
    var value = textAreaElement.value || '';
    var selectionStart = textAreaElement.selectionStart;
    var selectionEnd = textAreaElement.selectionEnd;
    var pre = value.slice(0, selectionStart);
    var selection = value.slice(selectionStart, selectionEnd);
    var post = value.slice(selectionEnd);
    return { selection: selection, preSelection: pre, postSelection: post };
};
var getActiveFormatters = function (textAreaElement) {
    var result = [];
    var wrappingTypes = exports.getFormatterTypesOfKind('wrapping');
    var insertTypes = exports.getFormatterTypesOfKind('insert');
    if (!textAreaElement) {
        return result;
    }
    var _a = getSelectionAndAdjacents(textAreaElement), selection = _a.selection, preSelection = _a.preSelection, postSelection = _a.postSelection;
    wrappingTypes.concat(insertTypes).forEach(function (formatterType) {
        var formatter = exports.FormatterMap[formatterType].formatter;
        switch (exports.FormatterMap[formatterType].formatterApplicationType) {
            case 'wrapping':
                if (MarkupFormatters_1.isSelectionWrapped(selection, formatter) || MarkupFormatters_1.isSelectionWrappedAdjacent(preSelection, postSelection, formatter)) {
                    result.push(formatterType);
                }
                break;
            case 'insert':
                if (MarkupFormatters_1.isInsertFormatterActive(preSelection, selection, formatter)) {
                    result.push(formatterType);
                }
                break;
            default:
                return;
        }
    });
    return result;
};
exports.getActiveFormatters = getActiveFormatters;
var getFormatterTypesOfKind = function (kind) {
    return TypedKeys_1.typedKeys(exports.FormatterMap).filter(function (type) { return exports.FormatterMap[type].formatterApplicationType === kind; });
};
exports.getFormatterTypesOfKind = getFormatterTypesOfKind;
function getMarkupFunction(type) {
    switch (type) {
        case 'insert':
            return MarkupFormatters_1.markupInsertFunction;
        case 'multiline':
            return MarkupFormatters_1.markupMultilineFunction;
        case 'wrapping':
        default:
            return MarkupFormatters_1.markupWrappingFunction;
    }
}
exports.FormatterMap = {
    Bold: {
        formatter: '**',
        formatterApplicationType: 'wrapping',
        keyboardShortcut: { keyLabel: 'b', keyCode: 66 },
    },
    Italic: {
        formatter: '__',
        formatterApplicationType: 'wrapping',
        keyboardShortcut: { keyLabel: 'i', keyCode: 73 },
    },
    Underline: {
        formatter: '+',
        formatterApplicationType: 'wrapping',
        keyboardShortcut: { keyLabel: 'u', keyCode: 85 },
    },
    Paragraph: {
        formatter: 'p. ',
        formatterApplicationType: 'insert',
        prepend: exports.lflf,
    },
    Heading1: {
        formatter: 'h1. ',
        formatterApplicationType: 'insert',
        prepend: exports.lflf,
    },
    Heading2: {
        formatter: 'h2. ',
        formatterApplicationType: 'insert',
        prepend: exports.lflf,
    },
    Heading3: {
        formatter: 'h3. ',
        formatterApplicationType: 'insert',
        prepend: exports.lflf,
    },
    UnorderedList: {
        formatter: '* ',
        formatterApplicationType: 'multiline',
        keyboardShortcut: {
            keyLabel: '7',
            keyCode: 56,
            shiftKey: true,
        },
    },
    OrderedList: {
        formatter: '# ',
        formatterApplicationType: 'multiline',
        keyboardShortcut: {
            keyLabel: '8',
            keyCode: 55,
            shiftKey: true,
        },
    },
    Link: {
        formatter: MarkupFormatters_1.linkFormatter,
        formatterApplicationType: 'insert',
        keyboardShortcut: { keyLabel: 'k', keyCode: 75 },
    }
};
exports.FormattersWithShortcuts = TypedKeys_1.typedKeys(exports.FormatterMap).filter(function (type) { return exports.FormatterMap[type].keyboardShortcut; });
exports.ShortcutKeys = exports.FormattersWithShortcuts.map(function (value) { return exports.FormatterMap[value].keyboardShortcut.keyCode; });
var getFormatterTypeFromShortcut = function (e) {
    var matchingKey = exports.FormattersWithShortcuts.find(function (key) {
        var _a, _b;
        var shiftMatch = !!((_a = exports.FormatterMap[key].keyboardShortcut) === null || _a === void 0 ? void 0 : _a.shiftKey) === e.shiftKey;
        var keyMatch = ((_b = exports.FormatterMap[key].keyboardShortcut) === null || _b === void 0 ? void 0 : _b.keyCode) === e.keyCode;
        return shiftMatch && keyMatch;
    });
    return matchingKey;
};
exports.getFormatterTypeFromShortcut = getFormatterTypeFromShortcut;
//# sourceMappingURL=MarkupHelpers.js.map